import { FC, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import { Modal, ModalProps } from 'modules/ui/modal';
import { ExternalCallData } from '../interfaces';

interface Props extends ModalProps {
  call: ExternalCallData;
}

export const UnassignedCallDetailsModal: FC<Props> = ({ open, onClose, call }) => {
  const { t } = useTranslation('common');

  // Ref to the first focusable element in the modal
  const focusRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (open && focusRef.current) {
      focusRef.current.focus();
    }
  }, [open]);

  return (
    <Modal open={open} onClose={onClose} title={t('unassigned_calls.details.title')}>
      <Box mt={2}>
        <Typography
          variant="h6"
          gutterBottom
          tabIndex={-1}
          ref={focusRef}
        >
          {t('call.list.customerName')}:
        </Typography>
        <Typography variant="body1">{call.client_name || '-'}</Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          {t('call.list.customerPhone')}:
        </Typography>
        <Typography variant="body1">{call.client_phone_number || '-'}</Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          {t('call.list.description')}:
        </Typography>
        <Typography variant="body1">{call.call_description || '-'}</Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="h6" gutterBottom>
          {t('call.list.callCreate')}:
        </Typography>
        <Typography variant="body1">{call.created_at || '-'}</Typography>
      </Box>
    </Modal>
  );
};
